import { action } from 'mobx';
import { TrainingRecordQuery } from '../../../../state/ducks/training/types';
import { FBEndpoint } from '../../../../ui/form.builder/defaults/FBEndpoint';
import FBRequest from '../../../../ui/form.builder/FBApi/FBApi.request';
import { PAGE_SIZE } from './helpers';
import { SearchLogRequestBody, SearchRequestBody, SearchRequestResponse } from './types';

export default class SearchState {
  public searchApi = new FBRequest<SearchRequestResponse, SearchRequestBody>(FBEndpoint.GlobalSearch);
  public trainingApi = new FBRequest<TrainingRecordQuery, never>(FBEndpoint.TrainingRecord);
  public searchLogApi = new FBRequest<void, SearchLogRequestBody>(FBEndpoint.GlobalSearchLog);

  @action public fetchSearch = (body: SearchRequestBody): void => {
    const { searchText, facets = [], limit = PAGE_SIZE, offset = 0, sort = [] } = body;

    this.searchApi.set({
      method: 'post',
      body: {
        searchText,
        facets,
        limit,
        offset,
        sort,
      },
    });
  };

  /**
   * Records a committed search for internal usage reporting.
   *
   * Only call this when the user has actually committed to a query (Enter, a
   * recent-search pick, or opening a result from the suggestions) — never from
   * the debounced typeahead, which would log query prefixes instead.
   *
   * Reporting must never disrupt searching, so this passes a callback to
   * swallow errors: FBRequest's default onError raises a toast.
   */
  @action public logSearch = (body: SearchLogRequestBody): void => {
    const searchText = body.searchText.trim();

    if (!searchText) {
      return;
    }

    this.searchLogApi.set(
      {
        method: 'post',
        body: { ...body, searchText },
      },
      () => undefined,
    );
  };

  @action public fetchTrainingRecord = (id: string): void => {
    this.trainingApi.set({
      url: `${FBEndpoint.TrainingRecord}/${id}`,
      method: 'get',
    });
  };

  @action public reset = (): void => {
    this.searchApi.data = undefined;
    this.trainingApi.data = undefined;
  };
}
